import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
export const MOBILE_ASSET_MODAL_NAVIGATION_ITEM_WIDTH = 40;
export const MobileAssetModalNavigationItem = /*#__PURE__*/ memo((param)=>{
    let { icon, id, isActive, label, onClick, order } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: isActive ? "filled" : "ghost",
        color: "grey",
        "data-testid": "MOBILE_ASSET_MODAL_NAVIGATION_ITEM",
        "data-navigation-id": id,
        icon: icon,
        label: label,
        onClick: onClick,
        size: "large",
        style: {
            order
        }
    });
});
MobileAssetModalNavigationItem.displayName = "MobileAssetModalNavigationItem";
